import "./LoginSignUpPopup.css";

import React, { useState } from "react";
import {
  loginUser,
  requestPasswordReset,
  signupUser,
} from "../../services/authService";

import { NavLink } from "react-router-dom";
import { updateUser } from "../../redux/reducers/userReducer";
import { useDispatch } from "react-redux";
import { useLoader } from "../../hooks/useLoader";

const Login = ({ onClose, showRegister = false }) => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const [signUpName, setSignUpName] = useState("");
  const [signUpEmail, setSignUpEmail] = useState("");
  const [signUpPassword, setSignUpPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [termsAndCondition, setTermsAndCondition] = useState<boolean>(false);

  const [isLogin, setIsLogin] = useState(!showRegister);
  const [signupSuccess, setSignupSuccess] = useState(false);

  const { showLoading } = useLoader();

  const dispatch = useDispatch();

  // Email validation helper function
  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLoginClick = () => {
    setIsLogin(true);
  };

  const handleSignUpClick = () => {
    setIsLogin(false);
    setSignupSuccess(false);
  };
  const handleTermsclick = () => {
    window.location.href = "/TermsOfUse";
  };

  const handleForgotPasswordClick = async () => {
    // Check if user is on login form and has entered email
    if (!isLogin) {
      alert("Please switch to Login tab to reset your password.");
      return;
    }

    if (!loginEmail.trim()) {
      alert("Please enter your email address first.");
      return;
    }

    if (!isValidEmail(loginEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      showLoading(true);
      await requestPasswordReset({ email: loginEmail });
      showLoading(false);
      alert(
        "Password reset link has been sent to your email address. Please check your inbox.",
      );
    } catch (error) {
      showLoading(false);
      console.error("Password reset request error:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to send reset email. Please try again.",
      );
    }
  };

  const onLoginBtnClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (loginEmail.length < 3 || loginPassword.length < 6) {
      return;
    }
    e.preventDefault();
    try {
      showLoading(true);
      const data = await loginUser({
        email: loginEmail,
        password: loginPassword,
        loginType: "manual",
      });
      dispatch(updateUser(data.data));
      localStorage.setItem("user_email", data?.data?.user?.user_id);
      showLoading(false);
      window.location.reload();
    } catch (e) {
      showLoading(false);
      alert(e.response?.data?.message || "Something went wrong, try again!");
      console.log("login error:", e);
    }
  };

  const onSignUpBtnClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (
      signUpName.length < 3 ||
      signUpEmail.length < 3 ||
      signUpPassword.length < 6 ||
      !termsAndCondition
    ) {
      return;
    }
    e.preventDefault();

    if (signUpPassword !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    try {
      showLoading(true);
      const data = await signupUser({
        name: signUpName,
        email: signUpEmail,
        password: signUpPassword,
        loginType: "manual",
        referralCode,
      });
      dispatch(updateUser(data));
      localStorage.setItem("user_email", data?.user?.user_id);
      showLoading(false);

      setSignupSuccess(true);

      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (e) {
      alert(e.response?.data?.message || "Something went wrong, try again!");
      showLoading(false);
      console.log("Signup error:", e);
    }
  };

  const signupBtnDisabled =
    signUpName.length < 3 ||
    signUpEmail.length < 3 ||
    signUpPassword.length < 6 ||
    !termsAndCondition;

  return (
    <div className="modal">
      <div className="modal-content-login-singup">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <div className="logo-container">
          <img src="./assets/logo_main.png" alt="close" className="logo" />
        </div>
        <div className="login-heading">Welcome to EuroIntelligence</div>

        <div className="auth-toggle">
          <button
            className={`btn ${isLogin ? "active" : ""}`}
            onClick={handleLoginClick}
          >
            Login
          </button>
          <button
            className={`btn ${!isLogin ? "active" : ""}`}
            onClick={handleSignUpClick}
          >
            Register
          </button>
        </div>
        {isLogin && (
          <div className="enter-text">
            Enter your registered email id and password
          </div>
        )}

        {signupSuccess ? (
          <div className="success-message">
            <p>Signup successful! Continue to Login...</p>
          </div>
        ) : isLogin ? (
          <form className="auth-form">
            <div className="form-group">
              <label htmlFor="login-email" className="login-email">
                Email ID
              </label>
              <input
                type="email"
                id="login-email"
                name="email"
                placeholder="Enter your email"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="login-password" className="login-email">
                Password
              </label>
              <input
                type="password"
                id="login-password"
                name="password"
                placeholder="Enter your password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                required
              />
            </div>
            <div className="forgot-section">
              <div className="remembermeContainer">
                <input type="checkbox" className="checkbox" />
                <span className="remember">Remember me</span>
              </div>
              <span
                className="forgotpassword"
                onClick={handleForgotPasswordClick}
                style={{ cursor: "pointer" }}
              >
                Create New Password ?
              </span>
            </div>
            <button
              onClick={onLoginBtnClick}
              type="submit"
              className="login-btn"
            >
              Login
            </button>
          </form>
        ) : (
          <form className="auth-form">
            <div className="form-group">
              <label htmlFor="signup-name" className="login-email">
                Name
              </label>
              <input
                type="text"
                className="input-container"
                id="signup-name"
                placeholder="Enter your Name"
                name="name"
                value={signUpName}
                onChange={(e) => setSignUpName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-email" className="login-email">
                Email ID
              </label>
              <input
                type="email"
                id="signup-email"
                name="email"
                className="input-container"
                value={signUpEmail}
                onChange={(e) => setSignUpEmail(e.target.value)}
                required
                placeholder="Enter your Email"
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-password" className="login-email">
                Password
              </label>
              <input
                type="password"
                id="signup-password"
                name="password"
                className="input-container"
                value={signUpPassword}
                onChange={(e) => setSignUpPassword(e.target.value)}
                required
                placeholder="Enter your Password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-confirm-password" className="login-email">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirm-password"
                name="confirm-password"
                className="input-container"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Enter your Password"
              />
            </div>
            <div className="form-group">
              <label htmlFor="signup-referral-code" className="login-email">
                Referral code
              </label>
              <input
                type="text"
                id="referral-code"
                name="referral-code"
                className="input-container"
                value={referralCode}
                onChange={(e) => setReferralCode(e.target.value)}
                required
                placeholder="Enter Referral code (optional)"
              />
              <div className="referral-code-info-wrapper">
                <svg
                  className="referral-code-info-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4M12 8h.01" />
                </svg>
                <p className="referral-code-info">
                  If you would like to subscribe as part of your organisation's
                  licence, please contact your subscription manager for the
                  referral code.
                </p>
              </div>
            </div>
            <div className="term-condition">
              <input
                type="checkbox"
                className="checkbox"
                defaultChecked={termsAndCondition}
                onChange={() => setTermsAndCondition((state) => !state)}
              />
              <span className="term-condition-text">
                I hereby agree to the Company’s{" "}
                <span className="terms-link" onClick={handleTermsclick}>
                  Terms and Condition
                </span>
              </span>
            </div>
            <button
              type="submit"
              onClick={onSignUpBtnClick}
              className={
                signupBtnDisabled ? "signup-btn-disabled" : "signup-btn"
              }
            >
              Register
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Login;
